var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-select',{attrs:{"disabled":_vm.disabled,"required":_vm.required,"value":_vm.value,"placeholder":"Select an institution","expanded":""},on:{"input":_vm.onInput}},_vm._l((_vm.data),function(option){return _c('option',{key:option.id,domProps:{"value":option.id}},[_vm._v(" "+_vm._s(option.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }